module.exports = __webpack_public_path__ + "img/until.ceef5715.png";